module.exports = __webpack_public_path__ + "assets/img/my-vip-page-bg.5fe75c44.png";